import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, FormRecord, NonNullableFormBuilder, Validators } from "@angular/forms";
import { provideNzIconsPatch } from "ng-zorro-antd/icon";
import { LanguageServices } from "src/app/services/LanguageServices";
import { CheckCircleTwoTone } from '@ant-design/icons-angular/icons';
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";
import { WebHookCommonServices } from "../../webhook-services/webhook-commom.services";

@Component({
    selector: 'webhook-form-keyvalue-object',
    templateUrl: './webhook-form-keyvalue-object.component.html',
    standalone: false,
    providers: [provideNzIconsPatch([CheckCircleTwoTone])]
})

export class WebhookFormKeyValueObjectComponent implements OnInit {
     constructor(
            private fb:NonNullableFormBuilder, 
            private cd:ChangeDetectorRef,
            public webhookServices:WebHookCommonServices
        
        ) {

    }

    controlEntries: { key: string; control: FormControl<any> }[] = [];

    pageIndex:number = 1;
    pageSize:number = 3;
    newRow = this.fb.group({
        key: ['', Validators.required],
        value: ['', Validators.required]
    });
    @Input() mainformGroup:FormGroup;
    @Input() field:any;
    @Input() n:number;

    @Input() fieldNew:string;
    @Input() variables:Variable[] = [];
    @Input() rootForm:FormGroup;
    @Input() configuration: any;
    
    filteredAutoCompleteKey:string[] = [];
    filteredAutoCompleteValue:string[] = [];
  
    ngOnInit(): void {

        this.fieldNew = this.field.field.split('.')[this.n];
        
        if ( this.field.autocompleteKey != null ){
            this.newRow.get("key")?.valueChanges.subscribe(value => {
                this.filteredAutoCompleteKey = this.field.autocompleteKey.filter(opt =>{
                        if ( value == null){
                            return [];
                        }
                        return opt.toLowerCase().includes(value.toLowerCase())
                    }
                );
            });
        }

        if ( this.field.autocompleteValue != null ){
            this.newRow.get("value")?.valueChanges.subscribe(value => {
                this.filteredAutoCompleteValue = this.field.autocompleteValue.filter(opt =>{
                        if ( value == null){
                            return [];
                        }
                        return opt.toLowerCase().includes(value.toLowerCase())
                    }
                );
            });
        }

        var mainControl:FormGroup = (this.mainformGroup.get(this.fieldNew) as FormGroup);
        this.controlEntries = Object.entries(mainControl.controls).map(([key, control]) => ({
                key,
                control: control as FormControl<any>
        }));

        
    }

    get rows(){
        return this.controlEntries;
    }

    get pagedRows() {
        const start = (this.pageIndex - 1) * this.pageSize;
        if ( this.rows == null ){
            return [];
        }else{
            return this.rows.slice(start, start + this.pageSize);
        }
    }

    addRow() {
        
        if (this.newRow.valid) {
            var mainControl:FormGroup = (this.mainformGroup.get(this.fieldNew) as FormGroup);
            let key = this.newRow.get('key').value;
            let value = this.newRow.get('value').value;
            
            var control:FormControl<any> = new FormControl<any>(null);
            control.setValue(value);
           
            mainControl.addControl(key, control);
            
            this.controlEntries.push({ key, control });

            const total:number = this.rows.length as number;
            const pages = Math.ceil(total / this.pageSize);
            this.pageIndex = pages;

            this.newRow.reset();
        }
    }
    

    removeRow(index: number) {
        let key = this.controlEntries[index].key;
        var mainControl:FormGroup = (this.mainformGroup.get(this.fieldNew) as FormGroup);
        mainControl.removeControl(key);
        this.controlEntries.splice(index,1);
        this.cd.detectChanges();
    }

 

    openFormula(data:any, formControl:FormControl<any> = null){
        this.webhookServices.openFormula(data,this.variables,formControl);
    }

    selectedRow(row){
    }

}
